// extracted by mini-css-extract-plugin
export default {"footer":"style--footer--72e4dd"};